module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.lib.libMerge({"options":{"@root":{"widgets.googleAnalytics.widget":[{"value":"mcGoogleAnalytics","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101005},"path":"@root","_fox_":1}]},"@root #router":{"hooks.onStopExecute":[{"value":function() {
var counterCalls = 0;
var currentPage = this._passedRoute.path;
var self = this;
var tj = fox.getEnv('siteProps.trafficJunky');
var callback = function() {
counterCalls++;
if (!_gaScriptLoaded && counterCalls < 5) {
setTimeout(arguments.callee, 2000);
return;
}
var ga = self.rwom1('@root #googleAnalytics');
if (self.rwom1('@root').getOption('gaCodes')) {
ga.trackPageview(currentPage, true);
ga.addLinker();
}
}();
if (currentPage !== 'join' || !tj) {
return;
}
try {
tj = JSON.parse(tj);
} catch(e) {
console.error('TrafficJunky json parse error');
return;
}
_mpevt.push([[tj.context.replace('\.', '_'), '_event'].join('.'), tj.name, tj.value]);
},"lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101037},"path":"@root #router","_fox_":1}]}}})
 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/site/root/options/tracking.js
// module id = 701
// module chunks = 4